import { render, staticRenderFns } from "./Inactive.vue?vue&type=template&id=12f11630&scoped=true"
import script from "./Inactive.vue?vue&type=script&lang=js"
export * from "./Inactive.vue?vue&type=script&lang=js"
import style0 from "./Inactive.vue?vue&type=style&index=0&id=12f11630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f11630",
  null
  
)

export default component.exports